import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { randomboxApi } from '../../api/randombox.js';
import { Spinner, ErrorBox } from '../../components/ui.js';
import { OrderDrawer, useDrawerClose } from '../../components/OrderDrawer.js';
import { OrderEditor } from './OrderDetailPage.js';

/**
 * 목록 화면에서 주문번호를 클릭하면 목록은 그대로 두고 오른쪽에서 슬라이드로
 * 열리는 패널. 화면·데이터·저장 로직은 OrderDetailPage.tsx 의 OrderEditor 를
 * 그대로 쓰고, 오버레이 껍데기(배경 클릭·ESC·닫기)는 components/OrderDrawer 가
 * 맡는다 - lottery 주문 상세도 같은 껍데기를 쓴다.
 *
 * App.tsx 가 "background location" 패턴으로 이 라우트를 목록 위에 겹쳐 띄운다 -
 * 그래서 뒤에 있는 목록은 그대로 살아있는 컴포넌트다(다시 조회하지 않는다).
 */
export function RbOrderDetailModal() {
  const { orderNo = '' } = useParams();
  const queryClient = useQueryClient();
  const close = useDrawerClose('/randombox/orders');

  const query = useQuery({
    queryKey: ['randombox', 'order', orderNo],
    queryFn: () => randomboxApi.order(orderNo),
    enabled: Boolean(orderNo),
  });

  return (
    <OrderDrawer onClose={close} className="rb-order-drawer">
      {query.isPending ? (
        <Spinner />
      ) : query.isError ? (
        <ErrorBox error={query.error} onRetry={() => void query.refetch()} />
      ) : (
        <OrderEditor key={orderNo} orderNo={orderNo} data={query.data} queryClient={queryClient} onClose={close} />
      )}
    </OrderDrawer>
  );
}
